import { set } from '~/src/base/Optic';
import State, { ctweaks } from '../State';
import { defFigureMod } from '~/src/figure/FigureMod';

export interface ResetTweaks {
	tag : 'ResetTweaks';
}

export const resetTweaks : ResetTweaks = { tag : 'ResetTweaks' };

export const exeResetTweaks = ( state : State , _ : ResetTweaks ) : State =>
	set( ctweaks )( defFigureMod )( state );
